// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { Join_abstract } from './../../abstract/SagaBase/Objects/Join_abstract';
export class Join extends Join_abstract {}
